import React, { Component } from "react";
import JoditEditor from "jodit-react";
export class WarmUpClass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      content: "",
      // pos: 0,
      open: false,
      selectedVar: "",
      fallBackText: "",
      toggleDiv: false,
      selectedFolder: "",
      folderName: "",
      allUserTemplate: [],
      templateName: "",
      subject: "",
    };
  }
  updateContent = (value) => {
    this.props.setEmailBody(value);
    // this.setState({
    //   pos: window.getSelection().getRangeAt(0).startOffset,
    // });
  };

  componentDidMount() {}

  componentWillUnmount() {
    // Remove the event listener when the component is unmounted
  }

   configuration = {
    buttons: [
      "bold",
      "italic",
      "underline",
      "|",
      "source",
      "image",
      "link",
      "|",
      "fontsize",
      "font",
      "link",
      "|",
    ],
    toolbarAdaptive: false,
    hidePoweredByJodit: true,
    placeholder: "Start writing something...",
    statusbar: false,
    addNewLine: false,
  };

  jodit;
  setRef = (jodit) => (this.jodit = jodit);
  render() {
    return (
      <>
        <div style={{ display: "flex", flexDirection: "column", gap: "2px",marginBottom:'8px' }}>
          <p
            style={{
              color: "#393939",
              fontFamily: "Source Sans 3",
              fontSize: "14px",
              fontWeight: 400,
              fontStyle: "normal",
            }}
          >
            Subject
          </p>
          <input
            value={this.props.subject}
            onChange={(e) => {
              this.props.setSubject(e.target.value);
            }}
            type="text"
            style={{
              outline: "none",
              padding: "8px",
              backgroundColor: "transparent",
              border: "1px solid #1C485F",
              borderRadius: "6px",
            }}
            placeholder="Enter subject here..."
          />
        </div>
        <div style={{ width: "100%" ,height:'50vh'}}>
          <JoditEditor
            ref={this.setRef}
             value={this.props.emailBody}
            config={this.configuration}
            tabIndex={1} // tabIndex of textarea
            onBlur={this.updateContent}
            // onChange={this.updateContent}
          />
        </div>
      </>
    );
  }
}

export default WarmUpClass;
